import React from 'react'
import { Box, Typography } from '@mui/material'

export default function DailyChart({ data }) {
    if (!data || data.length === 0) {
        return (
            <Box sx={{ py: 2, textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                    No activity data available
                </Typography>
            </Box>
        )
    }

    // Find max for scaling
    const maxCount = Math.max(...data.map(d => d.count), 1)

    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'flex-end',
            gap: 0.5,
            height: 120,
            p: 1,
            bgcolor: 'grey.50',
            borderRadius: 1
        }}>
            {data.map((item, index) => {
                const height = (item.count / maxCount) * 100
                const date = new Date(item.date)
                const dayLabel = date.toLocaleDateString('en', { weekday: 'short' })

                return (
                    <Box
                        key={index}
                        sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 0.5
                        }}
                    >
                        {/* Count label */}
                        <Typography variant="caption" sx={{ fontSize: '0.65rem' }}>
                            {item.count}
                        </Typography>
                        {/* Bar */}
                        <Box
                            sx={{
                                width: '100%',
                                height: `${height}%`,
                                minHeight: item.count > 0 ? 4 : 1,
                                bgcolor: item.count > 0 ? 'primary.main' : 'grey.300',
                                borderRadius: 0.5,
                                transition: 'height 0.3s ease'
                            }}
                        />
                        {/* Date label - show only for some bars to avoid clutter */}
                        {(index === 0 || index === data.length - 1 || index % 7 === 0) && (
                            <Typography variant="caption" sx={{ fontSize: '0.6rem', color: 'text.secondary' }}>
                                {dayLabel}
                            </Typography>
                        )}
                    </Box>
                )
            })}
        </Box>
    )
}
